import PropTypes from 'prop-types';

export default {
  id: PropTypes.string,
  cityId: PropTypes.string,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  minPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  propertyTypes: PropTypes.arrayOf(PropTypes.string),
  mediums: PropTypes.arrayOf(PropTypes.string),
  cityAreaIds: PropTypes.arrayOf(PropTypes.string)
};
